<template>
  <el-container class="container">
    <el-header class="header-style">
      <el-divider content-position="left">财税工厂交接入审核列表</el-divider>
      <el-row>
        <el-col :span="10">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange"
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
          <el-popover placement="bottom-start" v-model="visible" width="520">
            <el-form :model="searchArr" ref="searchForm" label-width="100px">
              <el-form-item label="服务时间" prop="service_time">
                <el-date-picker
                  v-model="searchArr.service_time"
                  type="monthrange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  :picker-options="pickerMonthOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="审核状态" prop="status">
                <el-radio-group v-model="searchArr.status" size="mini">
                  <el-radio-button :label="1">已通过</el-radio-button>
                  <el-radio-button :label="2">审核中</el-radio-button>
                  <el-radio-button :label="3">已驳回</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="发起人" prop="founder">
                <el-cascader
                  style="width: 200px"
                  v-model="searchArr.founder"
                  placeholder="请选择发起人"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="发起时间" prop="created_at">
                <el-date-picker
                  v-model="searchArr.created_at"
                  type="date"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  placeholder="发起时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table
        height="calc(100vh - 276px)"
        :data="companies"
        size="medium"
        border
        style="width: 100%"
        v-cloak
      >
        <el-table-column label="公司名称" width="360" fixed>
          <template slot-scope="scope">
            <div style="white-space: nowrap; overflow: auto">
              <el-tooltip
                :content="scope.row.company.company_name"
                placement="top"
                style="display: inline-block"
              >
                <el-link
                  type="primary"
                  class="count-style"
                  @click="handleCompanyInfoOpen(scope.row.company_id)"
                  >{{ scope.row.company.company_name }}</el-link
                >
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="复制" placement="top">
                <i
                  class="el-icon-document-copy"
                  style="margin-left: 0.1rem; cursor: pointer"
                  @click="copySome(scope.row.company.company_name)"
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务时间" width="250">
          <template slot-scope="scope">
            <div v-if="scope.row.finance_order.length > 1">
              <el-link
                style="color: #409eff"
                @click="openServiceTimeDrawer(scope.row.finance_order)"
                >点击查看</el-link
              >
            </div>
            <div v-else-if="scope.row.finance_order.length === 1">
              <span
                >{{ scope.row.finance_order[0].service_started_at }} /
                {{ scope.row.finance_order[0].service_ended_at }}</span
              >
            </div>
            <div v-else>
              <span style="color: red"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否零申报" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.is_zero_declare === 0">否</span>
            <span v-else-if="scope.row.is_zero_declare === 1">是</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="140">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.created_at }}</span> -->
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.remark"
              placement="top"
            >
              <span>{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="发起交接人" width="100">
          <template slot-scope="scope" v-if="scope.row.founder">
            <span>{{ scope.row.founder.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核人员/时间" width="140">
          <template slot-scope="scope">
            <div class="custom-column-container">
              <span class="custom-column-item">{{ scope.row.reviewer_name }}</span>
              <el-tooltip class="item" effect="dark" content="审核时间" placement="top">
                <!-- <span class="custom-column-item">{{ scope.row.reviewered_at }}</span> -->
                <date-formatter :date-value="scope.row.reviewered_at"></date-formatter>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" width="300" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.reason ? scope.row.reason : "---" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="编辑" width="50" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleSwitchCheckOpen(scope.$index, scope.row)"
                circle
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="财务审核" fixed="right" width="140" align="center">
          <el-table-column label="通过" width="70">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="通过"
                placement="top"
                v-if="scope.row.status === 2"
              >
                <el-popconfirm
                  title="确认审核通过吗？"
                  @onConfirm="doConfirm(scope.$index, scope.row)"
                >
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    circle
                    slot="reference"
                  ></el-button>
                </el-popconfirm>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="已审核通过,点击打开财税登记表"
                placement="top"
                v-if="scope.row.status === 1"
              >
                <el-tag
                  size="mini"
                  effect="dark"
                  type="success"
                  style="cursor: pointer"
                  @click="$router.push('finance_taxation')"
                  >已通过</el-tag
                >
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="驳回" width="70">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="驳回"
                placement="top"
                v-if="scope.row.status === 2"
              >
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-close"
                  @click="handleSwitchCheckRefuse(scope.$index, scope.row)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tag
                v-if="scope.row.status === 3"
                size="mini"
                effect="dark"
                type="danger"
                >已驳回</el-tag
              >
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr"
        layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-size="pageOption.pageSize"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info
            :companyId="companyInfoId"
            @reloadTable="reloadTable"
            :checkType="checkComType"
          ></company-info>
        </el-row>
      </div>
    </el-drawer>

    <!-- 修改 -->
    <el-drawer
      title="编辑"
      :visible.sync="editSwitchCheckDrawer"
      direction="rtl"
      :before-close="closeSwitchOrCheckFromDrawer"
      size="60%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form :model="formData" label-width="100px" :rules="rules" ref="formData">
          <el-form-item label="当前公司" prop="company">
            <el-row>
              <el-col :span="23" style="font-size: 20px">
                {{ company }}
              </el-col>
              <!-- <el-col :span="1" :class="formData.status === 1 ? 'not-display' : ''">
                <el-tooltip class="item" effect="dark" content="新增订单" placement="top">
                  <i class="el-icon-circle-plus" style="font-size: 24px; margin-top: .16rem;cursor: pointer;"
                    @click="handleAddOrderComponents"></i>
                </el-tooltip>
              </el-col> -->
            </el-row>
          </el-form-item>
          <template v-if="formData.orderComponents.length <= 0">
            <el-form-item label="订单信息">
              <el-row :span="24">
                <el-col>
                  <span style="color: red">暂无订单信息</span>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item
              label="订单编号"
              v-for="(order, index) in formData.orderComponents"
              :label="'订单信息 ' + (index + 1)"
              :key="index"
            >
              <el-row :span="24">
                <el-col :span="8">
                  <el-form-item
                    :prop="'orderComponents.' + index + '.order_num'"
                    :rules="orderNumRules"
                  >
                    <el-input
                      type="text"
                      size="mini"
                      placeholder="请输入订单编号"
                      v-model="order.order_num"
                      prop="order_id"
                      :disabled="formData.status === 1 ? true : false"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" :offset="1">
                  <el-form-item
                    :prop="'orderComponents.' + index + '.service_started_at'"
                  >
                    <el-date-picker
                      v-model="order.service_started_at"
                      style="width: 80%"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM"
                      placeholder="选择服务开始时间"
                      :disabled="formData.status === 1 ? true : false"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :prop="'orderComponents.' + index + '.service_ended_at'">
                    <el-date-picker
                      v-model="order.service_ended_at"
                      style="width: 80%"
                      type="date"
                      size="mini"
                      value-format="yyyy-MM"
                      placeholder="选择服务结束时间"
                      :disabled="formData.status === 1 ? true : false"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="1" :class="formData.status === 1 ? 'not-display' : ''">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除订单"
                    placement="top"
                  >
                    <i
                      class="el-icon-remove"
                      style="font-size: 24px; margin-top: 0.16rem; cursor: pointer"
                      @click="handleRemoveOrderComponents(index)"
                    ></i>
                  </el-tooltip>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <!-- <el-form-item label="所属财务" prop="subsidiary_finance">
            <el-select v-model="formData.subsidiary_finance" placeholder="请选择财务人员" filterable clearable size="mini"
              :disabled="formData.status === 1 ? true : false">
              <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否零申报">
            <el-radio-group
              v-model="formData.is_zero_declare"
              size="mini"
              :disabled="formData.status === 1 || formData.status === 3 ? true : false"
            >
              <el-radio-button :label="0">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="企业备注" prop="remark">
            <el-input
              type="textarea"
              size="mini"
              placeholder="请输入备注"
              v-model="formData.remark"
              :disabled="formData.status === 1 ? true : false"
            ></el-input>
          </el-form-item>
          <el-form-item :class="formData.status === 1 ? 'not-display' : ''">
            <el-button
              type="primary"
              style="float: right; margin-top: 0.4rem"
              size="mini"
              @click="submitCheckForm('formData')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <!-- 订单信息 -->
    <el-drawer
      title="订单信息"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="checkOrderType"></order-info>
      </div>
    </el-drawer>
    <!-- 服务时间 -->
    <el-drawer
      title=""
      :visible.sync="ServiceTimeDrawer"
      direction="rtl"
      :before-close="handleCloseServiceTimeDrawer"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">服务时间</span>
      </template>
      <service-time :tyc_order_data="tycOrderData" />
    </el-drawer>

    <el-dialog
      title="审核驳回"
      :visible.sync="switchCheckRefuseDialog"
      :modal="true"
      width="30%"
      @close="handleCloseSwitchCheckRefuseDialog"
    >
      <el-form
        :model="switchCheckRefuseForm"
        :rules="switchCheckRefuseRules"
        ref="switchCheckRefuseForm"
        label-width="80px"
      >
        <el-form-item label="驳回原因" prop="reason">
          <el-input
            size="medium"
            type="textarea"
            v-model="switchCheckRefuseForm.reason"
            placeholder=""
            style="white-space: pre"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 0.2rem">
        <el-button
          type="info"
          size="medium"
          @click="HandleResetSwitchCheckRefuseForm('switchCheckRefuseForm')"
          >清空</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="HandleSwitchCheckRefuseSubmitForm('switchCheckRefuseForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import moment from "moment";
import ServiceTime from "./components/ServiceTime";
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "Companies",
  components: {
    CompanyInfo,
    OrderInfo,
    ServiceTime,
    DateFormatter,
  },
  data() {
    return {
      cId: null,
      searchArr: {
        company_id: "",
        service_time: "",
        status: "",
        founder: "",
        created_at: "",
      },
      checkComType: this.$feedBackConfig.com_chat,
      checkOrderType: this.$feedBackConfig.order_chat,
      visible: false,
      searchLoading: false,
      companies: [],
      searchCompanies: [],
      adminUsers: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      company: "",
      companyInfoDrawer: false,
      companyInfoId: null,
      searchChatLoading: false,
      rules: {
        // subsidiary_finance: [
        //   { required: true, message: '请选择所属财务', trigger: 'blur' }
        // ]
      },
      orderNumRules: [{ required: true, message: "请输入订单编号", trigger: "blur" }],
      // serviceStartedAtRules: [
      //   { required: true, message: '请选择服务开始时间', trigger: 'change' },
      // ],
      // serviceEndedAtRules: [
      //   { required: true, message: '请选择服务结束时间', trigger: 'change' },
      // ],
      editSwitchCheckDrawer: false,
      formData: {
        id: "",
        orderComponents: [],
        company_name: "",
        company_id: null,
        is_zero_declare: "0",
        // subsidiary_finance: null,
        remark: "",
        status: null,
      },
      orderInfoVisible: false,
      orderInfoId: null,
      id: null,
      ServiceTimeDrawer: false,
      tycOrderData: [],
      switchCheckRefuseDialog: false,
      switchCheckRefuseRules: {
        reason: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
          { min: 1, max: 255, message: "填写过长", trigger: "blur" },
        ],
      },
      switchCheckRefuseForm: {
        reason: "",
      },
      finance_check_id: null,
      finance_check_data_index: null,
      pickerMonthOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    openServiceTimeDrawer(data) {
      this.ServiceTimeDrawer = true;
      this.$nextTick((_) => {
        this.tycOrderData = data;
      });
    },
    handleCloseServiceTimeDrawer(done) {
      this.tycOrderData = [];
      done();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    handleSwitchCheckPass(index, row) {
      this.$axios
        .get("api/admin/companies/checked_pass", {
          params: {
            id: row.id,
            company_id: row.company_id,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.companies[index]["status"] = 1;
            this.getFinanceSwitchLists();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    getFinanceSwitchLists() {
      this.$axios
        .get(
          "/api/admin/companies/get_finance_switch?page=" +
            this.pageOption.currentPage +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companies = data.data.companies.data;
            this.pageOption.total = data.data.companies.total;
            this.pageOption.currentPage = data.data.companies.current_page;
            this.adminUsers = data.data.adminUsers;
          }
        });
    },
    handleSwitchCheckOpen(index, row) {
      this.formData.id = row.id;
      this.company = row.company.company_name;
      this.formData.company_name = row.company.company_name;
      this.formData.company_id = row.company.id;
      // this.formData.orderComponents = row.company.orders
      // this.formData.subsidiary_finance = row.subsidiary_finance
      this.formData.is_zero_declare = row.is_zero_declare;
      this.formData.remark = row.remark;
      this.formData.status = row.status;
      this.$axios
        .get("/api/admin/tyc_order/get_com_order/?cid=" + row.id + "&type=2")
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.formData.orderComponents = data.data.orders;
          } else {
            this.$message.error(data.msg);
          }
        });
      this.editSwitchCheckDrawer = true;
    },
    submitCheckForm(formName) {
      if (this.formData.orderComponents.length <= 0) {
        this.$message.error("请新增订单信息！");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/company/switch_check", { formData: this.formData })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.editSwitchCheckDrawer = false;
                this.getFinanceSwitchLists();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleAddOrderComponents() {
      this.formData.orderComponents.push({ order_id: "", start_time: "", end_time: "" });
    },
    handleRemoveOrderComponents(index) {
      this.formData.orderComponents.splice(index, 1);
    },
    closeSwitchOrCheckFromDrawer(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.editSwitchCheckDrawer = false;
          this.formData.orderComponents = [];
          this.formData.status = null;
          this.$refs["formData"].resetFields();
          done();
        })
        .catch((_) => {});
    },
    handleOrderInfo(orderId) {
      //   if (!this.hasDecryptPhonePower) {
      //     this.$message.warning('暂无权限查看,请先联系管理员!')
      //     return false
      //   }
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      this.id = null;
      done();
    },
    //
    reloadTable() {
      this.getFinanceSwitchLists();
    },
    // 重置
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.getFinanceSwitchLists();
    },
    // 查询
    submitForm(formName) {
      this.visible = false;
      this.pageOption.currentPage = 1;
      this.getFinanceSwitchLists();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getFinanceSwitchLists();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getFinanceSwitchLists();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.getFinanceSwitchLists();
    },
    handleCompanyInfoOpen(cid) {
      setTimeout(() => {
        this.companyInfoId = cid;
      }, 100);
      this.companyInfoDrawer = true;
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    // 复制
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    doConfirm(index, row) {
      this.handleSwitchCheckPass(index, row);
    },
    handleSwitchCheckRefuse(index, row) {
      this.$axios
        .get("api/admin/companies/get_handover_in_review_power")
        .then(({ data }) => {
          if (data.code === 200) {
            this.finance_check_id = row.id;
            this.finance_check_data_index = index;
            this.switchCheckRefuseDialog = true;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    HandleResetSwitchCheckRefuseForm() {
      this.switchCheckRefuseForm = this.$options.data().switchCheckRefuseForm;
    },
    HandleSwitchCheckRefuseSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.switchCheckRefuseForm.id = this.finance_check_id;
          this.$axios
            .post(
              "api/admin/companies/handover_in_review_refuse",
              this.switchCheckRefuseForm
            )
            .then(({ data }) => {
              if (data.code === 200) {
                this.companies[
                  this.finance_check_data_index
                ].reason = this.switchCheckRefuseForm.reason;
                this.companies[this.finance_check_data_index].reviewer_name =
                  data.data["reviewer_name"];
                this.companies[this.finance_check_data_index].reviewered_at =
                  data.data["reviewered_at"];
                this.companies[this.finance_check_data_index].status = 3;
                this.handleCloseSwitchCheckRefuseDialog();
                this.switchCheckRefuseDialog = false;
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    handleCloseSwitchCheckRefuseDialog() {
      this.HandleResetSwitchCheckRefuseForm();
      this.finance_check_data_index = null;
      this.finance_check_id = null;
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getFinanceSwitchLists();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.container >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.container {
  marginLeft();
  max-height: 100vh;
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-style {
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    // background-color: #f5f5f5;
    .el-pagination {
      padding-top: 25px;
    }
  }
}

.custom-column-container {
  display: flex;
  flex-direction: column;
  height: 50px; /* 设置统一的高度 */
}

.custom-column-item {
  margin-bottom: 5px;
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}


.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 70%;
}
.not-edit{
  disabled: true !important;
}

.not-display {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/companies/FinanceSwitch.vue